export default __webpack_public_path__ + "static/media/C0052-0.7372ead2.jpg";